import { Typography } from "@mui/material";

export default function Footer({color='text.secondary'}) {
  return (
   <footer style={{marginBlock:'30px'}}>
        <Typography sx={{textAlign:'center', fontFamily:'Merriweather Sans', fontSize:16, color:color}}>
          &copy; {new Date().getFullYear()} esdras7.org — <a href="https://esdras7.org/esdras.php?/mque-privacy.html" style={{color:'inherit'}} target="_blank" rel="noopener noreferrer">Mentions légales</a>
        </Typography>
    </footer>
  );
}